// @flow
import React, {useState} from 'react';
import {
  Divider,
  Grid,
  IconButton,
  makeStyles,
  Tooltip,
  Typography,
} from '@material-ui/core';

import MoreHorizIcon from '@material-ui/icons/MoreHoriz';
import blogImg from '../../../../assets/img/blog.svg';
import communityImg from '../../../../assets/img/community.svg';
import resourcesImg from '../../../../assets/img/resources.svg';
import CustomButton from '../../../../elements/CustomButton/CustomButton';
import CommunityModal from './CommunityModal';
import {colors} from '../../../../assets/styles/colors';
import {useSidebarContext} from '../SidebarContainer';

type Props = {};

const shrinkStyle = {
  height: '140px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
};

const useStyles = props =>
  makeStyles(theme => ({
    aditionalResources: {
      color: '#9595AB',
      fontSize: '11px',
      margin: theme.spacing(2, 0),
    },
    resourcesWrapper: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
    },
    divider: {
      margin: theme.spacing(2, 1, 0, 1),
    },
    wrapperTitleResources: {
      padding: theme.spacing(2),
    },
    titleResources: {
      fontSize: '12px',
      fontWeight: 500,
      textTransform: 'uppercase',
      color: '#9595AB',
    },
    resources: {
      padding: theme.spacing(1),
    },
    resourcesButton: {
      backgroundColor: colors.grey300,
    },
    tooltip: {
      background: '#FFFFFF',
      boxShadow: '0px 4px 12px rgba(14, 21, 58, 0.08)',
      borderRadius: '4px',
      zIndex: 99999,
      color: colors.grey800,
      pointerEvents: 'none',
    },
    arrow: {
      color: '#FFFFFF',
    },
    tooltipDivider: {
      backgroundColor: '#EEEEF2',
    },
    tooltipContent: {
      pointerEvents: 'auto',
    },
    tooltipButton: {
      borderRadius: 'none',
    },
  }));

export default function AdditionalResources(props: Props) {
  const {shrink} = useSidebarContext();

  const classes = useStyles({shrink})();

  const [communityModal, setCommunityModal] = useState(false);

  const buildTooltipContent = () => {
    return (
      <div className={classes.tooltipContent}>
        <CustomButton
          className={classes.tooltipButton}
          fullWidth
          target="_blank"
          rel="noopener noreferrer"
          href="https://tiendadateam.notion.site/Recursos-TiendaDA-6c5fd232deef4f18a75bf7d00be96d75"
        >
          Recursos
        </CustomButton>
        <Divider className={classes.tooltipDivider} />
        <CustomButton
          className={classes.tooltipButton}
          fullWidth
          target="_blank"
          rel="noopener noreferrer"
          href="https://tiendada.com/blog"
        >
          Blog
        </CustomButton>
        <Divider className={classes.tooltipDivider} />
        <CustomButton
          className={classes.tooltipButton}
          fullWidth
          onClick={() => {
            setCommunityModal(true);
          }}
        >
          Comunidad
        </CustomButton>
      </div>
    );
  };

  if (shrink) {
    return (
      <>
        <Tooltip
          arrow
          title={buildTooltipContent()}
          placement="right-start"
          interactive
          classes={{
            tooltip: classes.tooltip,
            arrow: classes.arrow,
          }}
        >
          <div style={{height: 150}}>
            <Divider className={classes.divider} />
            <div className={classes.resources} style={shrinkStyle}>
              <IconButton className={classes.resourcesButton}>
                <MoreHorizIcon />
              </IconButton>
            </div>
          </div>
        </Tooltip>
        <CommunityModal
          open={communityModal}
          handleCloseModal={() => setCommunityModal(false)}
        />
      </>
    );
  }

  return (
    <>
      <Divider className={classes.divider} />
      <div className={classes.resources}>
        <Grid container>
          <Grid item xs={12}>
            <div className={classes.wrapperTitleResources}>
              <Typography className={classes.titleResources}>
                Recursos Adicionales
              </Typography>
            </div>
          </Grid>
          <Grid item xs={4}>
            <div className={classes.resourcesWrapper}>
              <CustomButton
                id="resources"
                target="_blank"
                rel="noopener noreferrer"
                href="https://tiendadateam.notion.site/Recursos-TiendaDA-6c5fd232deef4f18a75bf7d00be96d75"
              >
                <img src={resourcesImg} alt="resources" />
              </CustomButton>
              <Typography className={classes.aditionalResources}>
                Recursos
              </Typography>
            </div>
          </Grid>
          <Grid item xs={4}>
            <div className={classes.resourcesWrapper}>
              <CustomButton
                id="blog"
                target="_blank"
                rel="noopener noreferrer"
                href="https://tiendada.com/blog"
              >
                <img src={blogImg} alt="resources" />
              </CustomButton>
              <Typography className={classes.aditionalResources}>
                Blog
              </Typography>
            </div>
          </Grid>
          <Grid item xs={4}>
            <div className={classes.resourcesWrapper}>
              <CustomButton
                id="community"
                onClick={() => setCommunityModal(true)}
              >
                <img src={communityImg} alt="resources" />
              </CustomButton>
              <Typography className={classes.aditionalResources}>
                Comunidad
              </Typography>
            </div>
          </Grid>
        </Grid>
      </div>
      <CommunityModal
        open={communityModal}
        handleCloseModal={() => setCommunityModal(false)}
      />
    </>
  );
}
